import { css } from '@emotion/css';

export const iconStyle = css`
  width: 2rem;
  height: 2rem;
`;

export const listItemTypography = css`
  padding-inline-start: 1.6rem;
`;

export const tickedMenuItemMenuWidth = css`
  width: 21.2rem;
`;

export const addMenulistItemTypography = css`
  padding-inline-start: 1.2rem;
`;

export const menuItemSelectedStyle = css`
  &.Mui-focusVisible,
  &.Mui-selected {
    background-color: var(--s-info-light);
  }
`;
